/**
 * 语言配置工具函数
 * 提供各种编程语言的配置信息（文件扩展名、MIME 类型、Monaco 语言等）
 */

export const getLanguageConfig = (lang) => {
  switch (lang) {
    case 'racket':
      return {
        extension: 'rkt',
        mimeType: 'text/x-scheme',
        monacoLanguage: 'scheme',
        displayName: 'Racket'
      };
    case 'python':
    default:
      return {
        extension: 'py',
        mimeType: 'text/x-python',
        monacoLanguage: 'python',
        displayName: 'Python'
      };
  }
};

/**
 * 获取 Monaco Editor 语言标识符
 */
export const getMonacoLanguage = (lang) => {
  return getLanguageConfig(lang).monacoLanguage;
};

